export enum StepTypes {
    checkbox = 0,
    upload_file = 20,
    email = 1,
    document_request = 2,
    signature_request = 3,
    approval_request = 4,
    survey = 5,
    payment_request = 6,
    webhook = 7,
    appointment_request = 11,
    question_request = 12,
    checklist_request = 14
}

export let AutomaticStepTypes = [
    StepTypes.email,
    StepTypes.document_request,
    StepTypes.approval_request,
    StepTypes.survey,
    StepTypes.payment_request,
    StepTypes.webhook
];

export let ClientStepTypes = [
    StepTypes.email,
    StepTypes.document_request,
    StepTypes.approval_request,
    StepTypes.survey,
    StepTypes.payment_request,
    StepTypes.appointment_request,
    StepTypes.question_request,
    StepTypes.checklist_request
]



